import easyToUse from '../assets/easy-to-use.png';
import algorithm from '../assets/algorithm.png';
import privacy from '../assets/privacy.png'
import logoEn from '../assets/smg-logo-en.png'
import logoNo from '../assets/smg-logo-no.png'
import teacher from '../assets/teacher.png'
import clock from '../assets/clock.png'
import profits from '../assets/profits.png'
import battery from '../assets/battery.png'
import rocket from '../assets/rocket.png'
import classroom from '../assets/classroom.jpeg'
import student from '../assets/student.jpeg'
import graduation from '../assets/graduation-hat.png'
import youtube from '../assets/youtube.png'
import klassekart from '../assets/klassekart.jpeg'
import socialAdacemic from '../assets/social-academic.jpeg'
import teacherStudents from '../assets/teacher-students.jpeg'
import rotations from '../assets/rotations.jpeg'
import arrangements from '../assets/arrangements.jpeg'
import signupAdmin from '../assets/signupAdmin.png'
import manageGradesBtn from '../assets/manageGradesBtn.png'
import schoolYearInput from '../assets/schoolYearInput.png'
import gradeInput from '../assets/gradeInput.png'
import licenseCode from '../assets/licenseCode.png'
import signupTeacher from '../assets/signupTeacher.png'
import registerClass from '../assets/registerClass.png'
import selectSeating from '../assets/selectSeating.png'
import selectClass from '../assets/selectClass.png'
import preview from '../assets/preview.png'
import customArrangement from '../assets/customArrangement.png'
import manuallyPlace from '../assets/manuallyPlace.png'
import selectConditions from '../assets/selectConditions.png'
import sitTogether from '../assets/sitTogether.png'
import generatedMap from '../assets/generatedMap.png'
import viewMap from '../assets/viewMap.png'
import editClass from '../assets/editClass.png'
import editStudents from '../assets/editStudents.png'
import selectMap from '../assets/selectMap.png'

import privacy1 from '../assets/shutterstock_2292527159.jpg'
import privacy2 from '../assets/shutterstock_2156918769.jpeg'
import privacy3 from '../assets/shutterstock_2329333335.jpg'
import privacy4 from '../assets/shutterstock_489852166.jpg'
import privacy5 from '../assets/shutterstock_275251643.jpg'
import privacy6 from '../assets/shutterstock_2302949453.jpg'
import privacy7 from '../assets/shutterstock_1448047388.jpg'

export default {
    easyToUse, algorithm, privacy, logoEn, logoNo, teacher, clock, profits, battery,
    rocket, classroom, student, graduation, youtube, klassekart, socialAdacemic,
    teacherStudents, rotations, arrangements, signupAdmin, manageGradesBtn, schoolYearInput,
    gradeInput, licenseCode, signupTeacher, registerClass, selectSeating, selectClass, preview,
    customArrangement, manuallyPlace, selectConditions, sitTogether, generatedMap,
    viewMap, editClass, editStudents, selectMap,

    privacy1, privacy2, privacy3, privacy4, privacy5, privacy6, privacy7
}